'use strict'

var rationalize = require('./lib/rationalize')

module.exports = add

function add(a, b) {
  return rationalize(
    a[0].mul(b[1]).add(b[0].mul(a[1])),
    a[1].mul(b[1]))
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/big-rat/add.js
// module id = RnPF
// module chunks = 0